// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractModuleUi } from '../_abstract/ui';
/**
 * Component capable of rendering the `LiveFeedModule`'s contents.
 *
 * @author Kuba Fogel <kuba.fogel@movecloser.pl>
 */
let LiveFeedModuleUi = class LiveFeedModuleUi extends AbstractModuleUi {
};
LiveFeedModuleUi = __decorate([
    Component({ name: 'LiveFeedModuleUi' })
], LiveFeedModuleUi);
export { LiveFeedModuleUi };
